(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-numbers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-stats-numbers]').forEach(function (el) {
      new (function StatsNumbers(container) {
        var counters = container.querySelectorAll('[data-counter]');
        var animated = false;
        if (!counters.length) return;

        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && !animated) {
              animated = true;
              runAll();
            }
          });
        }, { threshold: 0.3 });

        observer.observe(container);

        function runAll() {
          var DURATION = 1800;
          counters.forEach(function (el) {
            var raw = el.dataset.counter;
            var decimals = (raw.split('.')[1] || '').length;
            var target = parseFloat(raw);
            var start = performance.now();

            (function tick(now) {
              var elapsed = now - start;
              var progress = Math.min(elapsed / DURATION, 1);
              var eased = 1 - Math.pow(1 - progress, 4);
              el.textContent = (eased * target).toFixed(decimals);
              if (progress < 1) requestAnimationFrame(tick);
              else el.textContent = target.toFixed(decimals);
            })(performance.now());
          });
        }
      })(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  class StoreLocator {
    constructor(root) {
      this.root = root;
      this.sidebar = root.querySelector('.sl__sidebar');
      this.grid = root.querySelector('.sl__grid');
      this.moreBtn = root.querySelector('.sl__more');
      this.mapEl = root.querySelector('[data-sl-map]');
      this.mapFrame = root.querySelector('.sl__map-frame');
      this.visibleCount = parseInt(root.dataset.visibleCount, 10) || 4;
      this.activeCity = 'all';

      this.cities = this.collectCities();
      if (this.cities.length === 0 && this.cards().length === 0) return;

      this.buildSidebar();
      this.bindMore();
      this.bindMapTriggers();
      this.apply();
      this.showDefaultMap();
    }

    showDefaultMap() {
      if (!this.mapFrame) return;
      const first = this.grid.querySelector('.store-card[data-map-query]');
      const query = first && first.dataset.mapQuery;
      if (query) this.showMap(query, first, false);
    }

    bindMapTriggers() {
      if (!this.mapFrame) return;
      this.grid.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-map-trigger]');
        if (!trigger || !this.grid.contains(trigger)) return;
        e.preventDefault();
        const card = trigger.closest('.store-card');
        const query = trigger.dataset.mapQuery || (card && card.dataset.mapQuery) || '';
        if (query) this.showMap(query, card);
      });
    }

    mapSrc(value) {
      const v = (value || '').trim();
      if (!v) return '';
      // Full <iframe ...> pasted — extract its src.
      const iframe = v.match(/src=["']([^"']+)["']/i);
      if (iframe) return iframe[1];
      // Already an embed URL.
      if (/^https?:\/\//i.test(v)) return v;
      // Address or "lat,lng" — build a keyless embed URL.
      return 'https://www.google.com/maps?q=' + encodeURIComponent(v) + '&output=embed';
    }

    showMap(query, card, scroll = true) {
      if (!this.mapFrame) return;
      const src = this.mapSrc(query);
      if (!src) return;
      this.mapFrame.src = src;
      this.mapFrame.hidden = false;
      if (this.mapEl) this.mapEl.classList.add('is-active');

      this.grid.querySelectorAll('.store-card.is-shown').forEach((el) => {
        el.classList.remove('is-shown');
      });
      if (card) card.classList.add('is-shown');

      if (scroll && this.mapEl) {
        // Align the map's top edge with the viewport top, leaving room
        // for the sticky header (measured live — height can vary).
        const header = document.getElementById('header-component');
        const offset = (header ? header.offsetHeight : 0) + 12;
        const top = this.mapEl.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }
    }

    collectCities() {
      const groups = Array.from(this.grid.querySelectorAll('.sl__city[data-city-id]'));
      return groups
        .map((el) => ({
          id: el.dataset.cityId,
          name: el.dataset.cityName || el.dataset.cityId,
          count: el.querySelectorAll('.store-card').length,
        }))
        .filter((c) => c.count > 0);
    }

    cards(city) {
      let selector = '.store-card';
      let scope = this.grid;
      if (city && city !== 'all') {
        const group = this.grid.querySelector('.sl__city[data-city-id="' + CSS.escape(city) + '"]');
        scope = group || this.grid;
      }
      return Array.from(scope.querySelectorAll(selector));
    }

    buildSidebar() {
      if (!this.sidebar || this.cities.length === 0) return;

      const d = this.root.dataset;
      const total = this.cities.reduce((sum, c) => sum + c.count, 0);

      const heading = document.createElement('p');
      heading.className = 'sl__side-heading';
      heading.textContent = d.labelCities || 'Orase';

      const totals = document.createElement('p');
      totals.className = 'sl__side-totals';
      totals.textContent =
        this.cities.length + ' ' + (d.wordCities || 'orase') + ' • ' + total + ' ' + (d.wordStores || 'magazine');

      const list = document.createElement('ul');
      list.className = 'sl__side-list';

      const rows = [{ id: 'all', name: d.labelAll || 'Toate', count: total }].concat(this.cities);
      rows.forEach((row) => {
        const li = document.createElement('li');
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'sl__side-btn';
        btn.dataset.city = row.id;
        btn.setAttribute('aria-current', row.id === this.activeCity ? 'true' : 'false');

        const label = document.createElement('span');
        label.className = 'sl__side-label';
        label.textContent = row.name;

        const count = document.createElement('span');
        count.className = 'sl__side-count';
        count.textContent = row.count;

        btn.append(label, count);
        btn.addEventListener('click', () => this.setCity(row.id));
        li.appendChild(btn);
        list.appendChild(li);
      });

      this.sidebar.append(heading, totals, list);
    }

    setCity(city) {
      if (city === this.activeCity) return;
      this.activeCity = city;
      this.sidebar.querySelectorAll('.sl__side-btn').forEach((btn) => {
        btn.setAttribute('aria-current', btn.dataset.city === city ? 'true' : 'false');
      });
      this.expanded = false;
      this.applyFade();
    }

    // Fade the visible cards out, swap the set, fade the new ones in.
    applyFade() {
      if (!this.grid) return this.apply();
      this.grid.classList.add('is-fading');
      window.setTimeout(() => {
        this.apply();
        void this.grid.offsetHeight; // reflow so new cards start at opacity 0
        this.grid.classList.remove('is-fading');
      }, 200);
    }

    bindMore() {
      if (!this.moreBtn) return;
      this.moreBtn.addEventListener('click', () => {
        this.expanded = true;
        this.apply();
      });
    }

    apply() {
      // City groups use display:contents, so we hide individual cards
      // rather than the group wrapper (which can't be hidden reliably).
      const visible = this.cards(this.activeCity);
      const limit = this.expanded ? visible.length : this.visibleCount;
      const shown = new Set(visible.slice(0, limit));

      this.cards().forEach((card) => {
        card.hidden = !shown.has(card);
      });

      // More button.
      if (this.moreBtn) {
        const hiddenCount = visible.length - limit;
        if (!this.expanded && hiddenCount > 0) {
          const text = (this.root.dataset.buttonText || 'Vezi toate cele').trim();
          const word = this.root.dataset.wordStores || 'magazine';
          this.moreBtn.hidden = false;
          this.moreBtn.innerHTML = '';
          this.moreBtn.append(
            document.createTextNode(text + ' ' + visible.length + ' ' + word + '  '),
            this.plusIcon()
          );
        } else {
          this.moreBtn.hidden = true;
        }
      }
    }

    plusIcon() {
      const span = document.createElement('span');
      span.setAttribute('aria-hidden', 'true');
      span.textContent = '+';
      span.style.fontSize = '20px';
      span.style.lineHeight = '1';
      return span;
    }
  }

  function initStoreLocators() {
    document.querySelectorAll('[data-store-locator]').forEach((el) => {
      if (el.dataset.slInit) return;
      el.dataset.slInit = '1';
      new StoreLocator(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStoreLocators);
  } else {
    initStoreLocators();
  }

  document.addEventListener('shopify:section:load', initStoreLocators);

  } catch(e) { console.error(e); }
})();
})();
